import { AppConfigModel } from "../../abstract/app-config.model";

export class LoanInstalmentOrigin extends AppConfigModel {

    static override CLASS_NAME: string = 'LoanInstalmentOrigin';
}
